"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingPromptSupply = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../utils");
var ReadingPrompt_1 = require("./ReadingPrompt");
var ReadingPromptSupply = function (_a) {
    var _b, _c;
    var fuel = _a.fuel, supplyInfo = _a.supplyInfo;
    if (!(0, utils_1.hasTradMeter)(supplyInfo)) {
        return null;
    }
    return (react_1.default.createElement(ReadingPrompt_1.ReadingPrompt, { lastActualElecRead: (_b = supplyInfo.electricity) === null || _b === void 0 ? void 0 : _b.latestRead, lastActualGasRead: (_c = supplyInfo.gas) === null || _c === void 0 ? void 0 : _c.latestRead, fuel: fuel }));
};
exports.ReadingPromptSupply = ReadingPromptSupply;
